import ProductAutosuggest from './ProductAutosuggest';

export default ProductAutosuggest;
